export default function requestLogout() {
    return {
        type: requestLogout.type,
    };
}

requestLogout.type = 'REQUEST_LOGOUT';
